import {
  INTEGRATION_CONNECTOR_TYPES,
  type IntegrationConnectorType,
} from '@marketing-hub/shared';
import { CONNECTOR_META, connectorShortLabel } from './integrationHelp';
import styles from './ConnectorTypePicker.module.css';

type Props = {
  value: IntegrationConnectorType;
  onChange: (type: IntegrationConnectorType) => void;
};

function avatarMod(type: IntegrationConnectorType): string {
  const mod = CONNECTOR_META[type].avatarClass;
  if (mod === 'gsc') return styles.avatarGsc;
  if (mod === 'ads') return styles.avatarAds;
  if (mod === 'psi') return styles.avatarPsi;
  if (mod === 'brevo') return styles.avatarBrevo;
  if (mod === 'wp') return styles.avatarWp;
  return styles.avatarGa4;
}

export function ConnectorTypePicker({ value, onChange }: Props) {
  return (
    <div className={styles.grid} role="radiogroup" aria-label="Connector type">
      {INTEGRATION_CONNECTOR_TYPES.map((type) => {
        const selected = value === type;
        const meta = CONNECTOR_META[type];
        return (
          <button
            key={type}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`${styles.option} ${selected ? styles.optionSelected : ''}`}
            onClick={() => onChange(type)}
          >
            <span className={`${styles.avatar} ${avatarMod(type)}`} aria-hidden>
              {connectorShortLabel(type)}
            </span>
            <span className={styles.text}>
              <span className={styles.name}>{meta.title}</span>
              <span className={styles.desc}>{meta.description}</span>
            </span>
            {selected ? (
              <span className={styles.check} aria-hidden>
                ✓
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
